























import { Vue, Component } from 'vue-property-decorator'
import {
  Group,
  XTextarea,
  XButton
} from '@lx-frontend/cvux'

@Component({
  components: {
    Group,
    XTextarea,
    XButton
  }
})

export default class ReceptionResult extends Vue {
  id: number = 0;
  appointment: { feedback: string } = { feedback: '' };
  isClicked: boolean = false;
  isFirstEnter: boolean = true;

  handleClose() {
    this.$wechat.promise.then((wx: { closeWindow: () => void; }) => {
      wx.closeWindow()
    }, (wx: { res: any; }) => {
      this.fetchNotification()
      throw new Error(`关闭页面失败：埋点错误WeixinJSBridge:${JSON.stringify(wx.res)}`)
    })
  }

  async fetchNotification() {
    const { query } = this.$route
    this.id = +query.id
    try {
      const res = await this.$rest.appointment.getArrivalNotification(this.id)()
      if (res.code === 0) {
        const { data = { context: { feedback: '' } } } = res
        this.appointment.feedback = data.context.feedback || ''
        if (this.isFirstEnter && data.context.feedback) {
          this.isClicked = true
        }
        this.isFirstEnter = false
      } else {
        this.showToast(res.message)
      }
    } catch (error) {
      console.error('获取结果备注信息失败', error)
    }
  }

  async handleComfirm() {
    if (this.appointment.feedback) {
      if (this.isClicked) return false
      this.isClicked = true
      try {
        const res = await this.$rest.appointment.updateArrivalNotification(this.id)({
          feedback: this.appointment.feedback
        })
        if (res.code === 0) {
          this.handleClose()
        } else {
          this.showToast(res.message)
        }
      } catch (error) {
        console.error('提交结果备注失败', error)
      }
      this.isClicked = false
    }
  }

  mounted() {
    this.fetchNotification()
  }
}

